module.exports = __webpack_public_path__ + "media/images/regions/Niamey-a398a73524e4319a6cfdc55628d8875a.png";